import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import cx from 'classnames';
import styles from './DropdownMenu-hashed.scss';

const DropdownMenuLink = (props, context) => {
    const {
        className, checked, disabled, children, onClick: onClickProp, visible, ...other
    } = props;

    if (visible === false) {
        return null;
    }

    const classes = cx(
        styles.link,
        {[styles.checked]: checked},
        {[styles.disabled]: disabled},
        className
    );

    const onClick = (disabled) ? (evt) => evt.preventDefault() : onClickProp;

    // FIX: warn if no 'to' and no 'onClick'?
    if (!other.to) {
        other.to = '#';
    }

    if (context && context.router) {
        return (
            <Link className={classes} onClick={onClick} disabled={disabled} {...other}>
                {children}
            </Link>
        );
    }
    return (
        <a className={classes} onClick={onClick} href={other.to} disabled={disabled} {...other}>
            {children}
        </a>
    );
};

DropdownMenuLink.propTypes = Object.assign(
    {},
    Link.propTypes,
    {
        to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        checked: PropTypes.bool,
        disabled: PropTypes.bool
    }
);

DropdownMenuLink.contextTypes = {
    router: PropTypes.shape({
        history: PropTypes.shape({
            push: PropTypes.func.isRequired,
            replace: PropTypes.func.isRequired,
            createHref: PropTypes.func.isRequired
        }).isRequired
    })
};

export default DropdownMenuLink;
